import React from "react";
import { connect } from "react-redux";

export const Hero = ({ className = "" }) => {
  return <div className={`hero__wrapper ${className}`} />;
};

const mapStateToProps = ({ router = {} }) => {
  const { result = {} } = router;
  const { className = "home" } = result;
  return {
    className,
  };
};
export default connect(mapStateToProps)(Hero);



// WEBPACK FOOTER //
// ./src/components/common/Hero.js